import { useContext, useMemo } from 'react';
import { ReportPeriodContext } from '../../../../context/report-periods/report-periods';

/**
 * Factor year derived from the organisation's report period picker, the same
 * notion manual activity entry uses. Rule dialogs override this with a saved
 * rule's own conversion year so its cascade rows still match.
 */
export function useConversionYearFromReportingSelection(): string {
  const reportPeriodContext = useContext(ReportPeriodContext);
  return useMemo(() => {
    const p = reportPeriodContext.allReportPeriods?.find(
      r => r.id === reportPeriodContext.lastSelectedReportId,
    );
    const raw = p?.conversionFiguresYear ?? p?.calendarYear;
    return raw != null && String(raw).trim() !== ''
      ? String(raw).trim()
      : String(new Date().getFullYear());
  }, [reportPeriodContext.allReportPeriods, reportPeriodContext.lastSelectedReportId]);
}
